import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { fetchList } from 'services/capabilityGroups/duck';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';

const Option = Select.Option;

class CapabilityGroupSelectContainer extends Component {
    componentDidMount() {
        this.props.fetchList();
    }

    onChange(input, value) {
        input.onChange(value.map(item => ({ id: item })));
    }

    static renderOptions(list) {
        return list.map((item, index) => (
            <Option key={index} value={item.id} searchtitle={item.name.toLowerCase()}>{item.name}</Option>
        ));
    }

    static filter(inputValue, node) {
        return node.props.searchtitle.includes(inputValue.toLowerCase());
    }

    render() {
        const { input } = this.props;

        if (this.props.list && this.props.list.length) {
            let currentValue = get(input, 'value', []);

            if (!Array.isArray(currentValue)) {
                currentValue = [];
            }

            return (
                <div id="scrolling-area-for-select" style={{ width: '100%' }}>
                    <Select
                        mode="multiple"
                        showSearch
                        onChange={this.onChange.bind(this, input)}
                        filterOption={CapabilityGroupSelectContainer.filter}
                        style={{ width: '100%', marginBottom: '20px' }}
                        dropdownStyle={{ overflow: 'auto', maxHeight: '40vh' }}
                        getPopupContainer={() => document.getElementById('scrolling-area-for-select')}
                        value={currentValue.map(item => item.id)}
                    >
                        {CapabilityGroupSelectContainer.renderOptions(this.props.list)}
                    </Select>
                </div>
            );
        }

        return null;
    }
}

const mapStateToProps = state => ({
    list: state.capabilityGroups.list
});

export { CapabilityGroupSelectContainer as __InternalClass };

export default connect(mapStateToProps, { fetchList })(CapabilityGroupSelectContainer);



// WEBPACK FOOTER //
// ./src/containers/CapabilityGroupSelectContainer.js